import { boot } from 'quasar/wrappers'
import VueShortKey from 'vue3-shortkey'

export default boot(({ app }) => {
  app.use(VueShortKey)
})
